import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import blogBg from "../../images/bg/blog-bg.png";
import gifShape from "../../images/icon/original-9e54f87f13d.gif";

import blogs from "../../api/blogs";

// Icons
import icon01 from "../../images/icon/blog-icon01.svg";
import icon02 from "../../images/icon/blog-icon02.svg";

const ArrowSvg: React.FC = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="5.06592" y="19.9785" width="20.5712" height="2.61221" transform="rotate(-40.2798 5.06592 19.9785)" fill="white" />
    <rect x="7.97095" y="7.24463" width="2.61221" height="2.61221" transform="rotate(-40.2798 7.97095 7.24463)" fill="white" />
    <rect x="11.6523" y="7.54834" width="2.61221" height="2.61221" transform="rotate(-40.2798 11.6523 7.54834)" fill="white" />
    <rect x="15.334" y="7.85205" width="2.61221" height="2.61221" transform="rotate(-40.2798 15.334 7.85205)" fill="white" />
    <rect x="18.7119" y="11.8374" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.7119 11.8374)" fill="white" />
    <rect x="18.4084" y="15.52" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.4084 15.52)" fill="white" />
    <rect x="18.104" y="19.2012" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.104 19.2012)" fill="white" />
  </svg>
);

const BlogSection: React.FC = () => {
  const featured = blogs[0];
  const smallPosts = blogs.slice(1, 3);

  useEffect(() => {
    const bgEl = document.querySelector<HTMLElement>(".blog.bg_img");
    if (bgEl) {
      bgEl.style.backgroundImage = `url(${blogBg})`;
    }
  }, []);

  return (
    <section className="blog pt-150 bg_img">
      <div className="container">
        <div className="row mt-none-30">
          {/* Left Column */}
          <div className="col-lg-4 mt-30">
            <div className="sec-title blog-sec-title mb-70">
              <span className="sub-title mb-15">SMM Guides</span>
              <h2 className="title">
                Grow faster with our tips <img src={gifShape} alt="shape" />
              </h2>
            </div>
            <div className="blog-btn">
              <Link className="thm-btn agency-btn" to="/blog">
                <span className="text">view all posts</span>
                <span className="arrow">
                  <span className="arrow-icon">
                    <ArrowSvg />
                    <ArrowSvg />
                  </span>
                </span>
              </Link>
            </div>
          </div>

          {/* Right Column */}
          <div className="col-lg-8 mt-30">
            <div className="row mt-none-30">
              {/* Large Blog Post */}
              {featured && (
                <div className="col-lg-12 mt-30">
                  <div
                    className="xb-blog-item wow fadeInUp"
                    data-wow-delay="0ms"
                    data-wow-duration="600ms"
                  >
                    <div className="xb-item--inner img-hove-effect xb-border">
                      <div className="xb-img">
                        {[...Array(4)].map((_, i) => (
                          <Link to={`/blog/${featured.slug}`} key={i}>
                            <img src={featured.image} alt={featured.title} />
                          </Link>
                        ))}
                      </div>
                      <div className="xb-item--holder">
                        <ul className="xb-item--meta list-unstyled ul_li">
                          <li>
                            <img src={icon01} alt="icon" /> {featured.tag}
                          </li>
                          <li>
                            <img src={icon02} alt="icon" /> {featured.date}
                          </li>
                        </ul>
                        <h2 className="xb-item--title">
                          <Link to={`/blog/${featured.slug}`}>
                            {featured.title}
                          </Link>
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {smallPosts.map((post, index) => (
                <div className="col-lg-6 col-md-6 mt-30" key={post.id}>
                  <div
                    className="xb-blog-item xb-small-blog-item wow fadeInUp"
                    data-wow-delay={`${(index + 1) * 150}ms`}
                    data-wow-duration="600ms"
                  >
                    <div className="xb-item--inner img-hove-effect xb-border">
                      <div className="xb-img">
                        {[...Array(4)].map((_, i) => (
                          <Link to={`/blog/${post.slug}`} key={i}>
                            <img src={post.image} alt={post.title} />
                          </Link>
                        ))}
                      </div>
                      <div className="xb-item--holder">
                        <ul className="xb-item--meta list-unstyled ul_li">
                          <li>
                            <img src={icon01} alt="icon" /> {post.tag}
                          </li>
                          <li>
                            <img src={icon02} alt="icon" /> {post.date}
                          </li>
                        </ul>
                        <h2 className="xb-item--title">
                          <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
